import { GOOGLE_PLAY_URL } from "@/lib/links";

// Badge oficial de Google Play (descargado de play.google.com/intl/.../badges, servido
// local). Los PNG vienen recortados a su bounding box para que su alto visual coincida
// con el badge de Apple, que no trae padding.
export const GooglePlayBadge = ({ t, lang, className = "h-[52px]", anchorClassName = "inline-flex", testId = "google-play-badge" }) => (
  <a
    href={GOOGLE_PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label={t.googlePlay.badgeAlt}
    className={`${anchorClassName} shrink-0 rounded-xl transition-transform hover:scale-[1.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F7931A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505]`}
  >
    <img
      src={`/googleplay/badge-${lang === "en" ? "en" : "es"}.png`}
      alt={t.googlePlay.badgeAlt}
      className={`${className} w-auto`}
    />
  </a>
);
